import { c as _c } from "react/compiler-runtime";
import { Handle, type HandleProps } from '@xyflow/react';
import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';
export type BaseHandleProps = HandleProps;
export function BaseHandle(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("size-2.75 rounded-full border border-slate-300 bg-slate-100 transition dark:border-secondary dark:bg-secondary", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <Handle {...props} className={t1}>{children}</Handle>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}